import { Capacitor } from '@capacitor/core';
export const isNativeApp = () => Capacitor.isNativePlatform();
export const ERP_WEBSITE = 'https://instill-erp.web.app';

export function publicAppOrigin() {
  const configured = process.env.REACT_APP_PUBLIC_APP_URL;
  if (configured) {
    const url = new URL(configured);
    if (url.protocol !== 'https:' || url.username || url.password) throw new Error('The public ERP address must be an HTTPS website.');
    return url.origin;
  }
  return isNativeApp() ? ERP_WEBSITE : window.location.origin;
}

export function publicAppLink(path) {
  if (!path.startsWith('/') || path.startsWith('//')) throw new Error('Use a relative ERP path.');
  return `${publicAppOrigin()}${path}`;
}

export function safeExportName(filename) {
  // Sanitize control characters as well as path separators in user-facing filenames.
  // eslint-disable-next-line no-control-regex
  const name = String(filename || 'ERP-export').replace(/[\\/:*?"<>|\u0000-\u001f]/g, '_').replace(/^\.+/, '').trim();
  return (name || 'ERP-export').slice(0, 150);
}

export function nativeDeepLinkPath(value) {
  try {
    const url = new URL(value);
    const custom = url.protocol === 'instilerp:' && url.hostname === 'open';
    const website = url.origin === publicAppOrigin();
    if ((!custom && !website) || url.username || url.password || url.pathname.startsWith('//')) return null;
    return `${url.pathname || '/'}${url.search}${url.hash}`;
  } catch { return null; }
}

export function requireDesktopBiometrics() {
  if (!isNativeApp()) return true;
  window.alert('This attendance method requires the configured desktop scanner. On this phone, use face attendance or submit a manual attendance request.');
  return false;
}
